/*
  innvolo-cotizar.js
  El asistente de `/cotizar`: arma la lista de productos, calcula y prepara el
  correo que se envía.

  DE DÓNDE SALEN LOS NÚMEROS
  De ninguno de estos renglones. Llegan en el JSON que imprime
  `sections/innvolo-cotizar.liquid` leyendo el admin —parámetros de precio,
  técnicas, precio y MOQ de cada producto—. Lo único que vive aquí es la
  aritmética de D-016, la misma del cotizador de la home y de la ficha:

    producto  = precio_base × (1 − desc_producto(cantidad))
    marcación = costo_tecnica × (1 − desc_marcacion(cantidad))
    unitario  = producto + marcación

  DE DÓNDE SALE LA LISTA
  De dos sitios que ya existían y que no se tocan:
    · la bandeja de la colección — localStorage `innvolo:cotizacion`, y el
      parámetro `?productos=handle,handle`
    · el botón de la ficha       — `?p=handle&cant=100&tec=bordado&color=Azul`

  QUÉ SE ENVÍA
  El formulario nativo de contacto de Shopify, que **solo admite texto**. El
  desglose se escribe en `contact[body]` antes de enviar. Ni la lista de
  empleados ni el logo van aquí: eso es la app de la Fase 3.
*/

(function () {
  'use strict';

  var LLAVE = 'innvolo:cotizacion';

  var raiz = document.querySelector('[data-innvolo-cotizar]');
  if (!raiz) return;

  var cuerpo = raiz.querySelector('[data-innvolo-cotizar-cuerpo]');
  var fuente = raiz.querySelector('[data-innvolo-cotizar-datos]');
  var plantilla = raiz.querySelector('[data-innvolo-linea-plantilla]');
  if (!cuerpo || !fuente || !plantilla) return;

  var DATOS;
  try {
    DATOS = JSON.parse(fuente.textContent);
  } catch (e) {
    return; /* Sin datos no se enseña una lista falsa: se deja el formulario. */
  }

  var PROD = DATOS.productos || [];
  var TEC = DATOS.tecnicas || {};
  var TOPES = DATOS.topes || [20, 50, 100, 500];
  var DESC = DATOS.descuentos || { producto: {}, marcacion: {} };

  var fmt = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

  function cop(n) {
    return '$' + fmt.format(Math.round(n));
  }

  /* ------------------------------------------------------------------
     D-016 — dos curvas independientes, ambas sobre el precio de la base
     ------------------------------------------------------------------ */

  function escalonDe(tabla, q) {
    var d = 0;
    for (var i = 0; i < TOPES.length; i++) {
      if (q >= TOPES[i] && tabla[TOPES[i]] != null) d = tabla[TOPES[i]];
    }
    return d;
  }

  function topeDe(q) {
    var t = TOPES[0];
    for (var i = 0; i < TOPES.length; i++) {
      if (q >= TOPES[i]) t = TOPES[i];
    }
    return t;
  }

  function calcula(prod, q, clave) {
    var prenda = prod.p * (1 - escalonDe(DESC.producto, q));
    var marca = clave && TEC[clave] ? TEC[clave].c * (1 - escalonDe(DESC.marcacion, q)) : 0;
    return { prenda: prenda, marca: marca, unit: prenda + marca };
  }

  /* Lo que costaría lo mismo sin ningún descuento, para poder decir cuánto se
     ahorra. Es el precio del escalón base, no un precio inventado. */
  function sinDescuento(prod, q, clave) {
    var marca = clave && TEC[clave] ? TEC[clave].c : 0;
    return (prod.p + marca) * q;
  }

  function porHandle(h) {
    for (var i = 0; i < PROD.length; i++) {
      if (PROD[i].h === h) return PROD[i];
    }
    return null;
  }

  /* ------------------------------------------------------------------
     Estado — qué hay en la cotización
     ------------------------------------------------------------------ */

  function lee() {
    try {
      var crudo = window.localStorage.getItem(LLAVE);
      var lista = crudo ? JSON.parse(crudo) : [];
      return Array.isArray(lista) ? lista : [];
    } catch (e) {
      return []; /* Incógnito o almacenamiento lleno: se sigue sin recordar. */
    }
  }

  function guarda() {
    try {
      window.localStorage.setItem(LLAVE, JSON.stringify(estado));
    } catch (e) {
      /* Sin persistencia, pero sin romper nada. */
    }
  }

  function olvida() {
    try {
      window.localStorage.removeItem(LLAVE);
    } catch (e) {
      /* nada */
    }
  }

  var params = new URLSearchParams(window.location.search);

  /* La bandeja guarda `{h, t}`; aquí se le añaden cantidad y técnica. Los
     campos de más no molestan a `innvolo-coleccion.js`, que solo lee `h` y `t`. */
  var estado = lee().filter(function (x) {
    return x && porHandle(x.h);
  });

  function mete(h, q, k) {
    var prod = porHandle(h);
    if (!prod) return;

    var ya = null;
    for (var i = 0; i < estado.length; i++) {
      if (estado[i].h === h) ya = estado[i];
    }
    if (!ya) {
      ya = { h: h, t: prod.t };
      estado.push(ya);
    }

    ya.q = Math.max(q || ya.q || prod.moq || TOPES[0], prod.moq || TOPES[0]);
    ya.k = k || ya.k || prod.k[0] || null;
  }

  /* Lo que llega de la bandeja de colección */
  var deBandeja = params.get('productos');
  if (deBandeja) {
    deBandeja.split(',').forEach(function (h) {
      mete(h.trim(), 0, null);
    });
  }

  /* Lo que llega del botón de la ficha, que trae cantidad y técnica elegidas */
  var deFicha = params.get('p');
  if (deFicha) {
    mete(deFicha, parseInt(params.get('cant'), 10) || 0, params.get('tec'));
  }

  /* Las líneas que vengan sin cantidad o sin técnica se completan con el
     mínimo del producto y su primera técnica permitida. */
  estado.forEach(function (x) {
    var prod = porHandle(x.h);
    if (!prod) return;
    if (!x.q) x.q = prod.moq || TOPES[0];
    if (!x.k) x.k = prod.k[0] || null;
    x.t = prod.t;
  });

  guarda();

  /* ------------------------------------------------------------------
     Pintado
     ------------------------------------------------------------------ */

  var lista = raiz.querySelector('[data-innvolo-lineas]');
  var vacia = raiz.querySelector('[data-innvolo-vacia]');
  var resumenCampo = raiz.querySelector('[data-innvolo-resumen]');
  var totales = raiz.querySelectorAll('[data-innvolo-total]');
  var pasos = raiz.querySelectorAll('[data-innvolo-paso-ir]');
  var botonesPaso = raiz.querySelectorAll('[data-innvolo-pasos] [data-innvolo-paso-ir]');

  function pintaLinea(item) {
    var prod = porHandle(item.h);
    if (!prod) return null;

    var nodo = plantilla.content.firstElementChild.cloneNode(true);
    nodo.dataset.innvoloLinea = item.h;

    var img = nodo.querySelector('[data-innvolo-linea-img]');
    if (prod.img) {
      img.src = prod.img;
      img.alt = prod.t;
    } else {
      img.remove();
    }

    var enlace = nodo.querySelector('[data-innvolo-linea-url]');
    enlace.href = prod.url;
    nodo.querySelector('[data-innvolo-linea-t]').textContent = prod.t;
    nodo.querySelector('[data-innvolo-linea-c]').textContent = prod.c;

    /* Las etiquetas ocultas nombran el producto: «Cantidad» a secas se repite
       tantas veces como líneas haya y el lector de pantalla no las distingue. */
    nodo.querySelector('[data-innvolo-linea-lbl-cant]').textContent = 'Cantidad de ' + prod.t;
    nodo.querySelector('[data-innvolo-linea-lbl-tec]').textContent = 'Técnica para ' + prod.t;

    var sel = nodo.querySelector('[data-innvolo-linea-tec]');
    prod.k.forEach(function (clave) {
      if (!TEC[clave]) return;
      var op = document.createElement('option');
      op.value = clave;
      op.textContent = TEC[clave].n;
      if (clave === item.k) op.selected = true;
      sel.appendChild(op);
    });
    if (prod.k.length < 2) sel.disabled = true;

    nodo.querySelector('[data-innvolo-linea-cant]').value = item.q;
    nodo.querySelector('[data-innvolo-linea-cant]').min = prod.moq || TOPES[0];

    lista.appendChild(nodo);
    return nodo;
  }

  function pintaCuentas() {
    var total = 0;
    var bruto = 0;
    var unidades = 0;

    estado.forEach(function (item) {
      var prod = porHandle(item.h);
      if (!prod) return;
      var c = calcula(prod, item.q, item.k);
      total += c.unit * item.q;
      bruto += sinDescuento(prod, item.q, item.k);
      unidades += item.q;

      var nodo = lista.querySelector('[data-innvolo-linea="' + item.h + '"]');
      if (!nodo) return;

      nodo.querySelector('[data-innvolo-linea-total]').textContent = cop(c.unit * item.q);
      nodo.querySelector('[data-innvolo-linea-unit]').textContent = cop(c.unit) + ' c/u';

      var tope = topeDe(item.q);
      var d = escalonDe(DESC.producto, item.q);
      nodo.querySelector('[data-innvolo-linea-escalon]').textContent = d
        ? 'escalón de ' + tope + ' uds −' + Math.round(d * 100) + '%'
        : '';

      var aviso = nodo.querySelector('[data-innvolo-linea-aviso]');
      var minimo = prod.moq || TOPES[0];
      aviso.hidden = item.q >= minimo;
      aviso.textContent = 'El mínimo de este producto son ' + minimo + ' unidades.';
    });

    var ahorro = bruto - total;

    totales.forEach(function (caja) {
      caja.querySelector('[data-innvolo-total-v]').textContent = cop(total);
      caja.querySelector('[data-innvolo-total-refs]').textContent =
        estado.length + (estado.length === 1 ? ' referencia' : ' referencias');
      caja.querySelector('[data-innvolo-total-uds]').textContent =
        fmt.format(unidades) + (unidades === 1 ? ' unidad' : ' unidades');

      var cajaAhorro = caja.querySelector('[data-innvolo-total-ahorro]');
      cajaAhorro.hidden = ahorro < 1;
      cajaAhorro.textContent =
        'Ahorras ' + cop(ahorro) + ' frente al precio de ' + TOPES[0] + ' unidades';
    });

    vacia.hidden = estado.length > 0;
    escribeResumen(total, unidades);
  }

  /* El texto que viaja en el correo. Se escribe siempre, no solo al enviar:
     si alguien envía el formulario con Enter, el resumen ya está puesto. */
  function escribeResumen(total, unidades) {
    if (!resumenCampo) return;

    var lineas = estado.map(function (item) {
      var prod = porHandle(item.h);
      if (!prod) return '';
      var c = calcula(prod, item.q, item.k);
      return (
        '- ' +
        prod.t +
        ' · ' +
        item.q +
        ' uds · ' +
        (item.k && TEC[item.k] ? TEC[item.k].n : 'sin marcación') +
        ' · ' +
        cop(c.unit) +
        ' c/u · ' +
        cop(c.unit * item.q)
      );
    });

    resumenCampo.value =
      'COTIZACIÓN\n' +
      lineas.join('\n') +
      '\n\n' +
      unidades +
      ' unidades en ' +
      estado.length +
      (estado.length === 1 ? ' referencia' : ' referencias') +
      '\nTotal antes de IVA: ' +
      cop(total) +
      '\n\nPrecios calculados en la web con los parámetros del admin.';
  }

  function pinta() {
    lista.innerHTML = '';
    estado.forEach(pintaLinea);
    pintaCuentas();
  }

  /* ------------------------------------------------------------------
     Interacción
     ------------------------------------------------------------------ */

  function itemDe(nodo) {
    var linea = nodo.closest('[data-innvolo-linea]');
    if (!linea) return null;
    for (var i = 0; i < estado.length; i++) {
      if (estado[i].h === linea.dataset.innvoloLinea) return estado[i];
    }
    return null;
  }

  lista.addEventListener('click', function (ev) {
    var paso = ev.target.closest('[data-innvolo-linea-paso]');
    if (paso) {
      var item = itemDe(paso);
      if (!item) return;
      var prod = porHandle(item.h);
      var minimo = prod.moq || TOPES[0];
      item.q = Math.max(minimo, item.q + parseInt(paso.dataset.innvoloLineaPaso, 10));
      paso.closest('[data-innvolo-linea]').querySelector('[data-innvolo-linea-cant]').value = item.q;
      guarda();
      pintaCuentas();
      return;
    }

    var quita = ev.target.closest('[data-innvolo-linea-quitar]');
    if (quita) {
      var fuera = itemDe(quita);
      if (!fuera) return;
      estado = estado.filter(function (x) {
        return x.h !== fuera.h;
      });
      guarda();
      pinta();
    }
  });

  lista.addEventListener('input', function (ev) {
    if (!ev.target.matches('[data-innvolo-linea-cant]')) return;
    var item = itemDe(ev.target);
    if (!item) return;
    item.q = parseInt(ev.target.value, 10) || 0;
    guarda();
    pintaCuentas();
  });

  /* El mínimo se aplica al salir del campo, no al teclear: si no, borrar para
     escribir otra cantidad salta al mínimo en cuanto el campo queda vacío. */
  lista.addEventListener('change', function (ev) {
    if (ev.target.matches('[data-innvolo-linea-cant]')) {
      var item = itemDe(ev.target);
      if (!item) return;
      var minimo = porHandle(item.h).moq || TOPES[0];
      if (item.q < minimo) item.q = minimo;
      ev.target.value = item.q;
      guarda();
      pintaCuentas();
      return;
    }

    if (ev.target.matches('[data-innvolo-linea-tec]')) {
      var linea = itemDe(ev.target);
      if (!linea) return;
      linea.k = ev.target.value;
      guarda();
      pintaCuentas();
    }
  });

  /* ------------------------------------------------------------------
     Pasos
     ------------------------------------------------------------------ */

  function ve(n) {
    if (n === '2' && !estado.length) return; /* sin dotación no hay paso 2 */
    cuerpo.dataset.innvoloPaso = n;
    botonesPaso.forEach(function (b) {
      if (b.dataset.innvoloPasoIr === n) {
        b.setAttribute('aria-current', 'step');
      } else {
        b.removeAttribute('aria-current');
      }
    });
    if (cuerpo.scrollIntoView) cuerpo.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  raiz.addEventListener('click', function (ev) {
    var ir = ev.target.closest('[data-innvolo-paso-ir]');
    if (ir && !ir.disabled) ve(ir.dataset.innvoloPasoIr);
  });

  /* ------------------------------------------------------------------
     NIT — dígito de verificación de la DIAN
     Avisa, no bloquea: un NIT extranjero o un formato raro no puede impedir
     que alguien pida un precio.
     ------------------------------------------------------------------ */

  var PESOS = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];

  function digitoNit(base) {
    var suma = 0;
    for (var i = 0; i < base.length; i++) {
      suma += parseInt(base.charAt(base.length - 1 - i), 10) * PESOS[i];
    }
    var resto = suma % 11;
    return resto > 1 ? 11 - resto : resto;
  }

  var campoNit = raiz.querySelector('[data-innvolo-nit]');
  var avisoNit = raiz.querySelector('[data-innvolo-nit-aviso]');

  if (campoNit && avisoNit) {
    campoNit.addEventListener('change', function () {
      var limpio = campoNit.value.replace(/[^0-9-]/g, '');
      var partes = limpio.split('-');
      var base = partes[0].replace(/\D/g, '');

      avisoNit.textContent = '';
      avisoNit.removeAttribute('data-innvolo-estado');

      if (base.length < 6 || base.length > 15) return;

      var dv = digitoNit(base);

      if (partes.length < 2 || partes[1] === '') {
        campoNit.value = base + '-' + dv;
        avisoNit.textContent = 'Le añadimos el dígito de verificación: ' + dv;
        avisoNit.setAttribute('data-innvolo-estado', 'bien');
        return;
      }

      if (parseInt(partes[1], 10) !== dv) {
        avisoNit.textContent = 'Revisa el NIT: el dígito de verificación debería ser ' + dv + '.';
        avisoNit.setAttribute('data-innvolo-estado', 'mal');
      } else {
        avisoNit.textContent = 'NIT correcto.';
        avisoNit.setAttribute('data-innvolo-estado', 'bien');
      }
    });
  }

  /* ------------------------------------------------------------------
     Arranque
     ------------------------------------------------------------------ */

  pinta();

  /* Enviada: se borra lo guardado. Si no, el que vuelve se encuentra su
     dotación otra vez y no sabe si llegó a enviarse. */
  if (cuerpo.dataset.innvoloPaso === '3') {
    olvida();
    var terminado = raiz.querySelector('[data-innvolo-pasos] [data-innvolo-paso-ir="3"]');
    if (terminado) terminado.disabled = false;
  }

  cuerpo.dataset.innvoloListo = 'si';
})();
